// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/arrival-anticipation.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/arrival-anticipation/arrival-anticipation.js';

mount([g0]);
